import { ref } from '@vue/composition-api'
import useAppConfig from '@core/app-config/useAppConfig'
import i18n from '@/libs/i18n'

export default function useAppCustomizer() {
  // Customizer
  const isCustomizerOpen = ref(false)

  // Skin
  const skinOptions = [
    { text: i18n.t('Light'), value: 'light' },
    { text: i18n.t('Bordered'), value: 'bordered' },
    { text: i18n.t('Dark'), value: 'dark' },
    { text: i18n.t('Semi Dark'), value: 'semi-dark' },
  ]

  // Content Width Options
  const contentWidthOptions = [
    { text: i18n.t('Full  Width'), value: 'full' },
    { text: i18n.t('Boxed'), value: 'boxed' },
  ]

  // Router Transition
  const routerTransitionOptions = [
    { title: i18n.t('Zoom Fade'), value: 'zoom-fade' },
    { title: i18n.t('Fade'), value: 'fade' },
    { title: i18n.t('Fade Bottom'), value: 'fade-bottom' },
    { title: i18n.t('Slide Fade'), value: 'slide-fade' },
    { title: i18n.t('Zoom Out'), value: 'zoom-out' },
    { title: i18n.t('None'), value: 'none' },
  ]

  // Router Transition
  const layoutTypeOptions = [
    { text: i18n.t('Vertical'), value: 'vertical' },
    { text: i18n.t('Horizontal'), value: 'horizontal' },
  ]

  // Navbar
  const navbarColors = ['', 'primary', 'secondary', 'success', 'danger', 'warning', 'info', 'dark']

  // Navbar Types
  const navbarTypes = [
    { text: i18n.t('Floating'), value: 'floating' },
    { text: i18n.t('Sticky'), value: 'sticky' },
    { text: i18n.t('Static'), value: 'static' },
    { text: i18n.t('Hidden'), value: 'hidden' },
  ]

  // Footer Types
  const footerTypes = [
    { text: i18n.t('Sticky'), value: 'sticky' },
    { text: i18n.t('Static'), value: 'static' },
    { text: i18n.t('Hidden'), value: 'hidden' },
  ]

  // eslint-disable-next-line object-curly-newline
  const {
    isRTL,
    skin,
    contentWidth,
    routerTransition,
    layoutType,
    isNavMenuHidden,
    isVerticalMenuCollapsed,
    navbarBackgroundColor,
    navbarType,
    footerType,
  } = useAppConfig()

  return {
    // Customizer
    isCustomizerOpen,

    // Vertical Menu
    isVerticalMenuCollapsed,

    // Skin
    skin,
    skinOptions,

    // Content Width
    contentWidth,
    contentWidthOptions,

    // RTL
    isRTL,

    // routerTransition
    routerTransition,
    routerTransitionOptions,

    // Layout Type
    layoutType,
    layoutTypeOptions,

    // NavMenu Hidden
    isNavMenuHidden,

    // Navbar
    navbarColors,
    navbarTypes,
    navbarBackgroundColor,
    navbarType,

    // Footer
    footerTypes,
    footerType,
  }
}
